module.exports = __webpack_public_path__ + "6ba575e839d8ae4881a9565d4d27ce02.svg";